export default __webpack_public_path__ + "95d8543d36efe0e29360d3aef2081486.svg";